export default {
    4001: '认证失败，无法访问系统资源',
    404: '访问资源不存在',
    4002: '拒绝访问！',
    4005: '未支付请先完成支付',
    6001: '未登录quickadmin'
}



// WEBPACK FOOTER //
// ./src/utils/errorCode.js